module.exports = __webpack_public_path__ + "assets/img/broadcastextn.6dc49a15.png";